module.exports = "module.exports = \"data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iNDAiIGhlaWdodD0iNDAiIHZpZXdCb3g9IjAgMCA0MCA0MCIgdmVyc2lvbj0iMS4xIiB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciPjxnIHN0cm9rZT0ibm9uZSIgc3Ryb2tlLXdpZHRoPSIxIiBmaWxsPSJub25lIiBmaWxsLXJ1bGU9ImV2ZW5vZGQiIHN0cm9rZS1saW5lY2FwPSJyb3VuZCI+PGcgc3Ryb2tlPSIjQkRCRkMxIiBzdHJva2Utd2lkdGg9IjIiPjxwYXRoIGQ9Ik0xNSAzM2gxME05IDM4bDMtOG0xOSA4bC0zLThtLTgtMS43NWM0IDAgMTEtMi41IDExLTExLjI1LTYtMi0xNi0yLTIyIC4yNSAwIDguNzUgNyAxMSAxMSAxMXpNMTQuOTIgMkMyMSA4IDEzIDMgMTMgN3M2IDIgMyA1bTYuOTItMTBDMjkgOCAyMSAzIDIxIDdzNiAyIDMgNSIvPjwvZz48L2c+PC9zdmc+\""


/*****************
 ** WEBPACK FOOTER
 ** ./~/raw-loader!./images/repairs/deck.svg
 ** module id = 3578
 ** module chunks = 3
 **/